import GiftOrderApi from '@apis/gift/GiftOrderApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const giftOrderQueries = createQueryKeys('giftOrder', {
    detail: (giftOrderNo: string) => ({
        queryKey: [giftOrderNo],
        queryFn: () => GiftOrderApi.getGiftOrder(giftOrderNo),
    }),
    result: (orderNo: string) => ({
        queryKey: ['result', orderNo],
        queryFn: () => GiftOrderApi.getGiftOrderResult(orderNo),
    }),
});

export default giftOrderQueries;
